import React, { Component } from "react";
import { DemoLinks } from "./Home";

const showcaseData = [
  {
    title: "Restaurant",
    url: "https://restaurant.ElasticCART.com",
    img: "restaurant.png",
  },
  {
    title: "Grocery",
    url: "https://Supermarket.ElasticCART.com",
    img: "grocery.png",
  },
  {
    title: "Fruits And Vegetables",
    url: "https://fruitsandvegetables.ElasticCART.com",
    img: "fruitsandvegetables.png",
  },
  {
    title: "Veg-Restaurant",
    url: "https://vegrestaurant.ElasticCART.com",
    img: "vegrestaurant.png",
  },
  {
    title: "Fashions",
    url: "https://fashion.ElasticCART.com",
    img: "fashions.png",
  },
  {
    title: "Sarees",
    url: "https://sarees.ElasticCART.com",
    img: "sarees.png",
  },
  {
    title: "Mobile Shop",
    url: "https://mobileshop.ElasticCART.com",
    img: "mobileshop.png",
  },
  {
    title: "Cake Shop",
    url: "https://Bakery.ElasticCART.com",
    img: "bakery.png",
  },
  {
    title: "Jewellery",
    url: "https://jewellery.ElasticCART.com",
    img: "jewelry.png",
  },
  {
    title: "Furniture",
    url: "https://Furniture.ElasticCART.com",
    img: "furniture.png",
  },
  {
    title: "Floral",
    url: "https://floral.ElasticCART.com",
    img: "floral.png",
  },
  {
    title: "Books",
    url: "https://books.ElasticCART.com",
    img: "books.png",
  },
  {
    title: "Electronics",
    url: "https://electronics.ElasticCART.com",
    img: "electronics.png",
  },
  {
    title: "Pharmacy",
    url: "https://pharma.ElasticCART.com",
    img: "pharma.png",
  },
  {
    title: "Meat Shop",
    url: "https://Meatshop.ElasticCART.com",
    img: "meatshop.png",
  },
  {
    title: "Music Store",
    url: "https://musicstore.ElasticCART.com",
    img: "musicstore.png",
  },
  {
    title: "Machinery",
    url: "https://machinery.ElasticCART.com",
    img: "machinery.png",
  },
  {
    title: "Aquiarium",
    url: "https://aquarium.ElasticCART.com",
    img: "aquiarium.png",
  },
  {
    title: "Plants & Nursery",
    url: "https://nursery.ElasticCART.com",
    img: "nursery.png",
  },
  {
    title: "Bikes & Cars Accessories",
    url: "https://bikencar.ElasticCART.com",
    img: "bikescarsaccessories.png",
  },
  {
    title: "Footwear",
    url: "https://footwear.ElasticCART.com",
    img: "footwear.png",
  },
  {
    title: "Sports & Gears",
    url: "https://sports.ElasticCART.com",
    img: "sports.png",
  },
];

export class Showcase extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="container py-5" id="showcases">
        <div className="border-start border-5 border-primary py-2 mb-4">
          <h6 className="text-primary text-uppercase">Showcase / Demo</h6>
          <h5 className="display-6 mb-0">
            <b>ECommerce (Online Store) Demo Sites</b>
          </h5>
        </div>
        <div className="row g-4">
          {showcaseData.map((item, idx) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex" key={idx}>
              <div className="service-item bg-light flex-fill d-flex flex-column p-3 rounded shadow-sm h-100">
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <h5 className="text-uppercase mb-3 text-dark">
                    {item.title}
                  </h5>
                  <div className="border-dark mb-2">
                    <img
                      className="w-100 rounded"
                      src={
                        "https://ecprdstorage01.blob.core.windows.net/elasticcart/images/" +
                        item.img
                      }
                      alt={item.title}
                      style={{
                        objectFit: "contain",
                        aspectRatio: "1/1",
                        maxHeight: "180px",
                        background: "#fff",
                      }}
                    />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
        <DemoLinks />
      </div>
    );
  }
}
